import { createSelector } from '@ngrx/store';
import { getStoryblokSEOState } from '../feature.selector';
import { StorySeoState } from '../state';

export const getStoryblokSeoContent = createSelector(
  getStoryblokSEOState,
  (state: StorySeoState) => state.storyblokSeo.storyblokSEOContent
);

export const isStoryblokSeoLoading = createSelector(
  getStoryblokSEOState,
  (state: StorySeoState) => state?.storyblokSeo?.loading
);

export const hasStoryblokContent = createSelector(getStoryblokSEOState, (state: StorySeoState) => {
  return !state?.storyblokSeo?.loading && !!state.storyblokSeo.storyblokSEOContent?.story;
});
